import React from 'react';
export default function Inline(props) {
  const {
    children
  } = props;
  const childCount = React.Children.toArray(children).length;
  if (!childCount) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
  }
  return children;
}